import { render, staticRenderFns } from "./ProductsTypesPage.vue?vue&type=template&id=05e7bc0e&scoped=true&"
import script from "./ProductsTypesPage.vue?vue&type=script&lang=js&"
export * from "./ProductsTypesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e7bc0e",
  null
  
)

export default component.exports